<template>
  <!-- <f7-page class="EditAccountMember"> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="page-content">
      <div class="layoutTop"/>

      <div class="container-fluid">
        <div class="row">
          <div class="col-md-10 offset-md-1 ">
            <div class="row form-group ml-0">
              <div class="row rowSearchBar">

                <div class="showSmallScreenOnly">
                  <f7-fab class="leftfav2 button-fab bottomButton floatingButtonToolbarBlank milkyBlockBlack" @click="refreshList">
                    <f7-icon f7="refresh"></f7-icon>
                  </f7-fab>
                </div>

                <div class="firstButtonMarginLeft showLargeScreenOnly">
                  <button class="new-button-white milkyBlockBlack" @click="refreshList">
                    <f7-icon f7="refresh"></f7-icon>
                    <span class="fab-label">{{ $t('common.rfrsh') }}</span>
                  </button>
                </div>

              </div>
            </div>
            <div class="panel21 panel-default float-none">
              <div class="form-group row">
                <label class="col-5 col-sm-2 col-form-label">{{ $t('rights.rights_profile') }}</label>
                <div class="col-7 col-sm-10">
                  <select class="form-control" id="sel4" v-model="selectedConfig" readonly>
                    <option :value="defaultConfig">{{ $t('rights.create_profile') }}</option>
                    <option v-for="config in configList"
                      :key="config.idProfile"
                      :value="config">
                      {{ config.libelleProfile }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group row" v-if="selectedConfig.idProfile !== -1">
                <div class="col-4 blackBottomButton" @click="deleteProfile">
                  <a class="button-round attachmentButton buttonAccordionForm longword-word button">
                    {{ $t('rights.delete_profile') }}
                  </a>
                </div>
              </div>

              <div>
                <rights-list
                  :userID="selectedConfig.idProfile"
                  :userRights="selectedConfig.rights"
                  :isNewProfile="(selectedConfig.idProfile === -1)"
                  :key="selectedConfig.idProfile">
                </rights-list>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3 offset-md-9">
                <button round
                class="milkyBlockBlack button-action firstButtonMarginTop"
                @click="saveProfile">
                  <i class="icon fa fa-save"></i>
                  <span>{{ $t('common.sve') }}</span>
                </button>
                <div class="toolbarPageBottomBlank"></div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import rightsList from '@/components/rights/rightsList.vue'

export default {
  name: 'RightsConfigs',
  components: {
    'rights-list': rightsList
  },
  data () {
    return {
      configList: [],
      selectedConfig: {},
      configSave: {},
      defaultConfig: {}
    }
  },
  created () {
    this.refreshProfileList()
    this.defaultConfig.rights = {}
    this.defaultConfig.idProfile = -1
    this.configSave.rights = {}
    this.configSave.idProfile = -1
  },
  watch: {
    selectedConfig: function (newConfig, oldConfig) {
      this.selectedConfig = newConfig
      this.configSave = this.$R.clone(newConfig)
    }
  },
  methods: {
    saveProfile () {
      if (this.selectedConfig.idProfile === -1) {
        this.createNewProfileModal()
      } else {
        this.editProfileModal()
      }
    },
    refreshList () {
      this.refreshProfileList()
    },
    createNewProfileModal () {
      let that = this
      let profileNameInput = '<div class="item-input mt-1">'
      profileNameInput += '<input class="profileName w-100" placeholder="' + this.$t('rights.profile_name') + '"></input>'
      profileNameInput += '</div>'
      this.$f7.modal({
        title: this.$t('rights.name_profile'),
        afterText: profileNameInput,
        buttons: [
          {
            text: that.$t('common.accpt'),
            onClick: function () {
              // get the profile Name and remove all useless spaces (trim)
              let profileName = that.Dom7('input.profileName').val().replace(/^\s+|\s+$/g, '')
              if (!profileName) {
                that.$f7.alert('', that.$t('errors.profile_name_missing'))
                return
              }
              // send to the engine to create a new profile and refresh the list
              let users = []
              let usersRights = []
              for (const right in that.selectedConfig.rights) {
                if (that.selectedConfig.rights[right].state === '1') {
                  usersRights.push(right)
                }
              }
              that.$engine.rights.createProfile(profileName, users, usersRights)
              .then(resp => {
                // check response data ?
                that.refreshProfileList()
              })
              .catch(err => {
                that.handleError(err) // mixins errorHandlerMixins
              })
              return
            }
          }
        ]
      })
    },
    editProfileModal () {
      let that = this
      let addedRights = []
      let removedRights = []
      for (const right in this.selectedConfig.rights) {
        if (this.selectedConfig.rights[right].state !== this.configSave.rights[right].state) {
          if (this.selectedConfig.rights[right].state === '1') {
            addedRights.push(right)
          } else {
            removedRights.push(right)
          }
        }
      }
      if (addedRights.length === 0 && removedRights.length === 0) {
        this.$f7.alert('', this.$t('errors.no_right_modified'))
        return
      }
      this.$f7.modal({
        title: this.$t('rights.confirm_edit_profile'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$engine.rights.editProfile(that.selectedConfig.idProfile, that.selectedConfig.libelleProfile, [], addedRights, removedRights)
              .then(resp => {
                that.$f7.alert('', that.$t('rights.rights_edited'))
              })
              .catch(err => {
                console.log(err)
              })
              return
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    deleteProfile () {
      let that = this
      this.$f7.modal({
        title: this.$t('rights.confirm_delete_profile'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$engine.rights.deleteProfile(that.selectedConfig.idProfile)
              .then(resp => {
                that.$f7.alert('', that.$t('rights.profile_deleted'))
                that.refreshProfileList()
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    refreshProfileList () {
      let that = this
      that.$engine.rights.getAllProfiles().then(resp => {
        that.configList = resp.profiles
      })
      that.selectedConfig = {}
      that.selectedConfig.rights = {}
      that.selectedConfig.idProfile = -1
    }
  }
}

</script>



// WEBPACK FOOTER //
// RightsConfigs.vue?bf4e450a